module.exports = __webpack_public_path__ + "img/Banner.ece31672.png";